// extracted by mini-css-extract-plugin
module.exports = {"box":"box_box__2bgV5","header":"box_header__1eqmQ","content":"box_content__1ym2G","footer":"box_footer__1geN8"};